import React from 'react';
import PropTypes from 'prop-types';
import SVGWrap from './SVGWrap';

const Wallet = ({ outlineColor, s }) => (
  <SVGWrap style={s}>
    <path
      fill={outlineColor}
      d="M459.2,66.2H71.6c-5.2,0-9.5-4.2-9.5-9.5s4.2-9.5,9.5-9.5h387.6c5.2,0,9.5,4.2,9.5,9.5S464.4,66.2,459.2,66.2z"
    />
    <path
      fill={outlineColor}
      d="M497,140.2v277.9c0,23-18.4,41-41.8,41H249.4c-5.2,0-9.5-4.2-9.5-9.5c0-5.2,4.2-9.5,9.5-9.5h205.8
	c13,0,22.9-9.5,22.9-22V140.2c0-12.6-9.8-22.1-22.9-22.1H71.6c-0.2,0-0.3,0-0.5,0c-14.3-0.1-27.4-5.6-37.3-14.5v313.1
	c0,13,10.3,22.8,24.1,22.8h89.4c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5H57.9c-24.1,0-43-18.3-43-41.8V61.5c0-0.2,0-0.3,0-0.5
	C15.1,29.6,39.7,5,71.1,4.7c0.2,0,0.3,0,0.5,0h387.6c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5H71.6c-21.6,0-37.8,16.3-37.8,37.8
	c0,20.9,17,37.8,37.8,37.8h383.6C478.7,99.3,497,117.3,497,140.2z"
    />
    <path
      fill={outlineColor}
      d="M252.6,410c-3.8,3.6-9.7,3.5-13.4-0.2L208.7,378v124.6c0,5.2-4.2,9.5-9.5,9.5c-5.2,0-9.5-4.2-9.5-9.5V378.3
	l-31.5,33.4c-1.9,2-4.4,3-6.9,3c-2.3,0-4.7-0.9-6.5-2.6c-3.8-3.6-4-9.6-0.4-13.4l47.8-50.8c0.1-0.1,0.1-0.1,0.2-0.2
	c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.2,0.7-0.5,1.1-0.6
	c0.4-0.2,0.8-0.4,1.3-0.5c0.3-0.1,0.6-0.2,1-0.3c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.5-0.1c0.3,0,0.6-0.1,0.9-0.1h0.1
	c1,0,1.9,0.1,2.8,0.4c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.2,0.9,0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2
	c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.2,0.6,0.5,0.9,0.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2
	l46.6,48.4C256.5,400.3,256.3,406.3,252.6,410z"
    />
  </SVGWrap>
);

Wallet.defaultProps = {
  s: {},
  outlineColor: '#000000',
};

Wallet.propTypes = {
  s: PropTypes.object,
  outlineColor: PropTypes.string,
};

export default Wallet;
